import { useEffect, useState } from 'react'
import { useVisitorData } from '@fingerprint/react'
import { getErrorMessage } from '../helpers/error'
import { getConfig, getRequestId, getVisitorId } from '../helpers/fpjs'
import { fetchVisitEventByRequestId } from '../helpers/smartSignals'
import { USE_DEMO_MOCK, MOCK_CURRENT_EVENT, MOCK_AGENT_DATA } from '../helpers/demoMock'
import type { VisitHistoryEvent } from '../types/visitHistory'

export const useSmartSignals = () => {
  const [currentEvent, setCurrentEvent] = useState<VisitHistoryEvent>()
  const [requestId, setRequestId] = useState<string>()
  const [visitorId, setVisitorId] = useState<string>()

  const { getData } = useVisitorData({ ...getConfig, immediate: false })

  const [hasError, setHasError] = useState(false)
  const [error, setError] = useState<string>()
  const [isLoading, setIsLoading] = useState(true)
  const [reload, setReload] = useState(false)

  useEffect(() => {
    async function getVisitorData() {
      setIsLoading(true)
      setHasError(false)

      if (USE_DEMO_MOCK) {
        setCurrentEvent(MOCK_CURRENT_EVENT)
        setRequestId(MOCK_CURRENT_EVENT.event_id)
        setVisitorId(MOCK_AGENT_DATA.visitor_id)
        setIsLoading(false)
        return
      }

      const data = await getData()
      const requestId = getRequestId(data)
      if (requestId) {
        setRequestId(requestId)
        setVisitorId(getVisitorId(data))

        try {
          const eventData = await fetchVisitEventByRequestId(requestId)
          setCurrentEvent(eventData)
        } catch (error) {
          setHasError(true)
          setError(getErrorMessage(error))
        }
        setIsLoading(false)
        setReload(false)
      } else {
        setHasError(true)
        setIsLoading(false)
        setReload(false)
      }
    }

    getVisitorData()
    // Adding getData to deps make double call to coreApi no homepage and demopage
    // eslint-disable-next-line
  }, [reload])

  const refresh = () => {
    setReload(true)
  }
  return { currentEvent, requestId, visitorId, isLoading, hasError, error, refresh }
}
